const RELOAD_STORAGE_KEY = 'chunkErrorReload';
const RELOAD_COOLDOWN_MS = 30000;

export function isChunkLoadError(error) {
  const message = typeof error === 'string' ? error : error?.message || '';
  return (
    error?.name === 'ChunkLoadError' ||
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed')
  );
}

// All recovery paths share a persisted cooldown, including after navigation.
export function reloadAfterChunkError() {
  try {
    const lastReload = Number(sessionStorage.getItem(RELOAD_STORAGE_KEY));
    const now = Date.now();
    if (lastReload && now - lastReload <= RELOAD_COOLDOWN_MS) return false;
    // Without a persisted guard, an unavailable chunk could cause a reload loop.
    sessionStorage.setItem(RELOAD_STORAGE_KEY, String(now));
    window.location.reload();
    return true;
  } catch {
    // Keep the existing error UI usable if storage or navigation is blocked.
    return false;
  }
}
